import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';

// ─── Page imports — Admin ─────────────────────────────────────
import AdminDashboard    from './admin/AdminDashboard';
import OrdersPage        from './admin/OrdersPage';
import TransactionsPage  from './admin/TransactionsPage';
import TrackingPage      from './admin/TrackingPage';
import InventoryPage     from './admin/InventoryPage';
import ArchivesPage      from './admin/ArchivesPage';
import MaintenancePage   from './admin/MaintenancePage';
import RegistrationPage  from './admin/RegistrationPage';
import ReportsPage       from './admin/ReportsPage';
import HelpPage          from './admin/HelpPage';

// ─── Page imports — Supplier ──────────────────────────────────
import SupplierDashboard  from './supplier/SupplierDashboard';
import SupplierInventory  from './supplier/SupplierInventory';
import SupplierTracking   from './supplier/SupplierTracking';
import SupplierReports    from './supplier/SupplierReports';
import SupplierHelp       from './supplier/SupplierHelp';

// ─── Page imports — Branch ────────────────────────────────────
import BranchDashboard      from './branch/BranchDashboard';
import BranchOrders         from './branch/BranchOrders';
import BranchTransactions   from './branch/BranchTransactions';
import BranchTracking       from './branch/BranchTracking';
import BranchWeeklyProfits  from './branch/BranchWeeklyProfits';
import BranchHelp           from './branch/BranchHelp';

// ─── Default landing page per role ───────────────────────────
const DEFAULT_PAGE = {
  admin:    'dashboard',
  supplier: 'dashboard',
  branch:   'dashboard',
};

// ─── Page registry: role → pageKey → component ───────────────
const PAGES = {
  admin: {
    dashboard:    AdminDashboard,
    orders:       OrdersPage,
    transactions: TransactionsPage,
    tracking:     TrackingPage,
    inventory:    InventoryPage,
    archives:     ArchivesPage,
    maintenance:  MaintenancePage,
    registration: RegistrationPage,
    reports:      ReportsPage,
    help:         HelpPage,
  },
  supplier: {
    dashboard: SupplierDashboard,
    inventory: SupplierInventory,
    tracking:  SupplierTracking,
    reports:   SupplierReports,
    help:      SupplierHelp,
  },
  branch: {
    dashboard:    BranchDashboard,
    orders:       BranchOrders,
    transactions: BranchTransactions,
    tracking:     BranchTracking,
    weeklyProfits: BranchWeeklyProfits,
    help:         BranchHelp,
  },
};

const shellStyle = {
  display: 'flex',
  minHeight: '100vh',
  background: 'var(--cream-dark)',
};

const mainStyle = {
  marginLeft: 'var(--sidebar-width)',
  flex: 1,
  padding: '2rem 2.5rem',
  minHeight: '100vh',
};

export default function AppLayout() {
  const { user } = useAuth();
  const [activePage, setActivePage] = useState(DEFAULT_PAGE[user?.role] || 'dashboard');
  const [navState,   setNavState]   = useState(null);

  if (!user) return null;

  function handleNavigate(page, state = null) {
    setActivePage(page);
    setNavState(state);
  }

  const pageMap   = PAGES[user.role] || {};
  const PageComponent = pageMap[activePage] || pageMap['dashboard'];

  return (
    <div style={shellStyle}>
      <Sidebar activePage={activePage} onNavigate={handleNavigate} />
      <main style={mainStyle}>
        {PageComponent
          ? <PageComponent onNavigate={handleNavigate} navState={navState} />
          : <p>Page not found.</p>}
      </main>
    </div>
  );
}
